/// <reference path="DOMAttached.js" />

class GameLoadTabAndPopupButton extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.popupLink = options.popupLink;
		this.tabLink = options.tabLink;
		this.tabApp = this.el.closest('.tabbedApplication').attachedObj;
		this.safeObserve(this.el.querySelector('input'), 'click', this.onClick.bind(this));
	}

	onClick(ev) {
		ev.preventDefault();
		ev.stopPropagation();
		if (this.tabLink != "") {
			document.querySelectorAll('.GNOMApplication')[0].querySelector('.popupContainer').attachedObj.loadPopup(this.popupLink, this.onPopupLoaded.bind(this));
		} else {
			document.querySelectorAll('.GNOMApplication')[0].querySelector('.popupContainer').attachedObj.showPopup(this.popupLink);
		}
	}

	onPopupLoaded(response) {
		this.popup = response;
		document.querySelectorAll('.GNOMApplication')[0].querySelector('.popupContainer').attachedObj.onPopupLoaded(this.popup);
		this.tabApp.loadPageWithOwnSuccessHandler(this.tabLink, this.onPageLoaded.bind(this));
	}

	onPageLoaded(response) {
		this.tabApp.currentTab.style.display = 'none';
		this.tabApp.selectTab(this.tabApp.findTab(this.tabLink));
		this.tabApp.onPageLoaded(response);
	}
}
